import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import formImg from '../images/form-bg.png'
import { useNavigate } from 'react-router';
import { Region } from '../types/regions';
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import { sendOTP } from '../services/otp-service';
import { Business } from '../types/business-plan';

const BusinessForm = (props: { regions: Region[], plans: Business[], setLoading: (loadingState: boolean) => void }) => {
    const freeTrial = false
    const navigate = useNavigate()
    console.log(props.plans)

    const next = async (data: any) => {
        try {
            props.setLoading(true)
            const result = await sendOTP(data.email)
            if (result.status) {
                navigate('/verification', { state: { ...data, account_type: 'small-business', is_free_trial: data.submitType } })
            }
            else {
                window.alert('An error occured while trying to send OTP')
            }
            props.setLoading(false)
        } catch (error) {
            console.log(error)
            props.setLoading(false)
            window.alert(error)
        }
    }

    const prices = props.plans.map((item: Business) => item.PlanPrice[0].unit_amount + '-' + item.PlanPrice[0].external_price_ref)
    console.log(prices)

    const planList = props.plans.map((item: Business, index: number) => {
        return (
            <div className='flex gap-3 justify-center' key={`${item}-${index}`}>
                <Field type='radio' name='plan' value={prices[index]} className='w-6 h-9' />
                <div className='flex flex-col gap-1 justify-center'>
                    <label htmlFor="" className='font-poppins font-semibold text-3xl text-black leading-none'>{item.plan_name}</label>
                    <label htmlFor="" className='text-sm font-light text-[#686868]'>{`*PRICING BASED ON 99 USERS OR LESS PAID PER ${item.PlanPrice[0].interval.toUpperCase()}`}</label>
                    <label className='leading-tight text-[#535353] font-bold'>
                        <div className='flex gap-1 text-[#1D58E2]'>
                            <p className='py-1 text-lg'>$</p>
                            <p className='text-6xl p-0 m-0'>{`${prices[index].split('-')[0].split('.')[0]}`}</p>
                            <p className='text-lg leading-none py-1.5'>{prices[index].split('-')[0].split('.')[1]}<br />
                                <span className='font-light'>per user/{item.PlanPrice[0].interval}</span></p>
                        </div>
                    </label>
                </div>
            </div>
        )
    })

    const regionsList = props.regions.map((item: Region) => {
        return (
            <option key={item.id} value={item.id}>{item.full_name}</option>
        )
    })


    return (
        <Formik
            initialValues={{ firstName: '', contact: '', lastName: '', email: '', orgName: '', license: '', designation: '', plan: prices[1], domain: '', region: '', policy: false, submitType: false }}
            validationSchema={Yup.object({
                firstName: Yup.string()
                    .matches(/^[A-Za-z ]+$/, 'Name cannot contain digits and special characters')
                    .min(2, 'Too short')
                    .max(70, 'Too long')
                    .required('First name cannot be empty'),
                lastName: Yup.string()
                    .matches(/^[A-Za-z ]+$/, 'Name cannot contain digits and special characters')
                    .min(2, 'Too short')
                    .max(70, 'Too long')
                    .required('Last name cannot be empty'),
                contact: Yup.string().required('Contact number cannot be empty'),
                email: Yup.string().email('Enter a valid email address').required('Email cannot be empty'),
                orgName: Yup.string().required('Organization name cannot be empty'),
                domain: Yup.string().matches(/^(([a-zA-Z]{1})|([a-zA-Z]{1}[a-zA-Z]{1})|([a-zA-Z]{1}[0-9]{1})|([0-9]{1}[a-zA-Z]{1})|([a-zA-Z0-9][a-zA-Z0-9-_]{1,61}[a-zA-Z0-9]))\.([a-zA-Z]{2,6}|[a-zA-Z0-9-]{2,30}\.[a-zA-Z]{2,3})$/, 'Invalid domain name').required('Domain cannot be empty'),
                license: Yup.number().moreThan(0, 'Number should be more than 0').lessThan(100, 'License count cannot be more than 99').required('Please enter the number of licenses required'),
                designation: Yup.string().required('Designation cannot be empty'),
                policy: Yup.boolean()
                    .required('You must accept the terms and conditions')
                    .oneOf([true], 'You must accept the terms and conditions.'),
                plan: Yup.string().oneOf(prices).required(''),
                region: Yup.number().required('Select a region'),
            })}
            onSubmit={(values) => {
                console.log(values)
                next(values)
            }}
        >{(props) => (
            <Form>
                <div className="flex flex-col gap-10 py-16 bg-no-repeat bg-cover bg-center" style={{ backgroundImage: `url(${formImg})` }}>
                    {freeTrial ? <div className="flex flex-col items-center text-center gap-1 w-10/12 mx-auto">
                        <p className="font-poppins font-semibold text-2xl"><span className="text-[#1D58E2]">FREE! TRIAL </span>for 14 days</p>
                        <p className="font-poppins font-normal text-md text-[#606060]">Before committing to our active Small Business Plan, you can sign  up for a free trial</p>
                    </div>
                        :
                        <div className="flex flex-col items-center text-center gap-1 w-10/12 mx-auto">
                            <p className="font-poppins font-semibold text-2xl">Discover our exclusive Business Plan</p>
                            <p className="font-poppins font-normal text-md text-[#606060]">Subscribe monthly/yearly, <span className='font-bold'>up to 99 licenses!</span></p>
                        </div>
                    }
                    <div className="flex flex-col items-center w-11/12 bg-white mx-auto rounded-lg py-10 gap-10 shadow-box2">
                        {!freeTrial && <div className='w-full flex items-center justify-center py-5'>
                            <div className='w-10/12 flex gap-40 max-[768px]:gap-8 justify-start'>
                                {planList}
                            </div>
                        </div>}
                        <div className="w-10/12 flex flex-col gap-10 justify-center">
                            <div id='personal-info' className="flex flex-col gap-7">
                                <p className="font-poppins font-medium text-xl">Personal Information</p>
                                <div className="flex max-[768px]:flex-col gap-3">
                                    <div className="flex flex-col gap-1 text-sm font-poppins flex-1">
                                        {/* <label htmlFor="firstName" className="font-semibold text-[#656565]">First Name <span className="text-red-500 ">*</span></label> */}
                                        <Field name="firstName" placeholder='First Name *' type="text" className={`bg-[#F5F8FA] border border-[#CBD6E2] py-2.5 px-2 rounded-md ${props.errors.firstName && props.touched.firstName && 'border border-red-500'}`} />
                                        <p className='text-red-500 text-xs font-poppins font-normal'><ErrorMessage name="firstName" /></p>
                                    </div>
                                    <div className="flex flex-col gap-1 text-sm font-poppins flex-1">
                                        {/* <label htmlFor="lastName" className="font-semibold text-[#656565]">Last Name <span className="text-red-500 ">*</span></label> */}
                                        <Field name="lastName" type="text" placeholder='Last Name *' className={`bg-[#F5F8FA] border border-[#CBD6E2] py-2.5 px-2 rounded-md ${props.errors.lastName && props.touched.lastName && 'border border-red-500'}`} />
                                        <p className='text-red-500 text-xs font-poppins font-normal'><ErrorMessage name="lastName" /></p>
                                    </div>
                                </div>
                                <div className="flex max-[768px]:flex-col gap-3">
                                    <div className='flex flex-col gap-1 flex-1 text-sm'>
                                        <PhoneInput
                                            placeholder="Contact No. *"
                                            value={props.values.contact}
                                            onChange={(value) => props.setFieldValue('contact', value)}
                                            className={`bg-[#F5F8FA] py-2.5 px-2 rounded-md border border-[#CBD6E2] ${props.errors.contact && props.touched.contact && 'border border-red-500'}`} />
                                        <p className='text-red-500 text-xs font-poppins font-normal'><ErrorMessage name="contact" /></p>
                                    </div>
                                    <div className="flex flex-col gap-1 text-sm font-poppins flex-1">
                                        {/* <label htmlFor="designation" className="font-semibold text-[#656565]">Your Designation <span className="text-red-500 ">*</span></label> */}
                                        <Field name="designation" placeholder='Your Designation *' type='text' className={`bg-[#F5F8FA] border border-[#CBD6E2] py-2.5 px-2 rounded-md ${props.errors.designation && props.touched.designation && 'border border-red-500'}`} />
                                        <p className='text-red-500 text-xs font-poppins font-normal'><ErrorMessage name="designation" /></p>
                                    </div>
                                </div>
                                <div className="flex max-[768px]:flex-col gap-3">
                                    <div className="flex flex-col gap-1 text-sm font-poppins flex-1">
                                        {/* <label htmlFor="email" className="font-semibold text-[#656565]">Business Email ID <span className="text-red-500 ">*</span></label> */}
                                        <Field name="email" type="text" placeholder='Enter Your Business Email ID *' className={`bg-[#F5F8FA] border border-[#CBD6E2] py-2.5 px-2 rounded-md ${props.errors.email && props.touched.email && 'border border-red-500'}`} />
                                        <p className='text-red-500 text-xs font-poppins font-normal'><ErrorMessage name="email" /></p>
                                    </div>
                                    <div className="flex flex-col gap-1 text-sm font-poppins flex-1">
                                        {/* <label htmlFor="region" className="font-semibold text-[#656565]">Region/Country<span className="text-red-500 ">*</span></label> */}
                                        <Field name="region" as='select' className={`bg-[#F5F8FA] ${props.values.region === '' && 'text-[#A7A7A7]'} h-[42px] border border-[#CBD6E2] py-2.5 px-2 h-10 rounded-md ${props.errors.region && props.touched.region && 'border border-red-500'}`} >
                                            <option value="" hidden disabled className="text-[#A7A7A7]">Region/Country *</option>
                                            {regionsList}
                                        </Field>
                                        <p className='text-red-500 text-xs font-poppins font-normal'><ErrorMessage name="region" /></p>
                                    </div>
                                </div>
                            </div>
                            <div id='organization-info' className="flex flex-col gap-7">
                                <p className="font-poppins font-medium text-xl">Organization Information</p>
                                <div className="flex flex-col gap-1 text-sm font-poppins">
                                    {/* <label htmlFor="orgName" className="font-semibold text-[#656565]">Organization Name <span className="text-red-500 ">*</span></label> */}
                                    <Field name="orgName" type="text" placeholder='Organization Name *' className={`bg-[#F5F8FA] border border-[#CBD6E2] py-2.5 px-2 rounded-md ${props.errors.orgName && props.touched.orgName && 'border border-red-500'}`} />
                                    <p className='text-red-500 text-xs font-poppins font-normal'><ErrorMessage name="orgName" /></p>
                                </div>
                                <div className="flex max-[768px]:flex-col gap-3">
                                    <div className="flex flex-col gap-1 text-sm font-poppins flex-1">
                                        {/* <label htmlFor="domain" className="font-semibold text-[#656565]">Organization Email Domain <span className="text-red-500 ">*</span></label> */}
                                        <Field name="domain" type="text" placeholder='Organization Email Domain *' className={`bg-[#F5F8FA] border border-[#CBD6E2] py-2.5 px-2 rounded-md ${props.errors.domain && props.touched.domain && 'border border-red-500'}`} />
                                        <p className='text-red-500 text-xs font-poppins font-normal'><ErrorMessage name="domain" /></p>
                                    </div>
                                    <div className="flex flex-col gap-1 text-sm font-poppins flex-1">
                                        {/* <label htmlFor="size" className="font-semibold text-[#656565]">Organization Size <span className="text-red-500 ">*</span></label> */}
                                        <div className="flex flex-col gap-1 text-sm font-poppins flex-1">
                                            {/* <label htmlFor="license" className="font-semibold text-[#656565]">No. of License <span className="text-red-500 ">*</span></label> */}
                                            <Field name="license" type="text" placeholder='No. of Licenses *' className={`bg-[#F5F8FA] border border-[#CBD6E2] py-2.5 px-2 rounded-md ${props.errors.license && props.touched.license && 'border border-red-500'}`} />
                                            <p className='text-red-500 text-xs font-poppins font-normal'><ErrorMessage name="license" /></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='flex flex-col gap-1'>
                                <div className="flex gap-3 items-center ">
                                    <Field type='checkbox' name="policy" className="w-4 h-4" />
                                    <label htmlFor="">By clicking here, you acknowledge that you have read the <span className="text-[#1D58E2] cursor-pointer">Privacy Policy</span> and agree to the <span className="text-[#1D58E2] cursor-pointer">Terms of Service</span></label>
                                </div>
                                <p className='text-red-500 text-xs font-poppins font-normal'><ErrorMessage name='policy' /></p>
                            </div>
                            {!freeTrial ? <div className="flex place-content-end gap-3">
                                <div className="flex flex-col items-end">
                                    <p className="text-sm font-poppins font-normal leading-none">For {props.values.license} users payable amount is:</p>
                                    <p className="text-[#1D58E2] font-semibold text-2xl">${(Number(props.values.license) * (Number(props.values.plan.split('-')[0]))).toFixed(2)}</p>
                                </div>
                                <button type='button' className="px-10 py-2 bg-[#1D58E2] w-fit text-white font-inter font-medium text-lg hover:bg-[#D2232A]" onClick={() => {
                                    props.setFieldValue('submitType', false)
                                    props.submitForm()
                                }}>Next</button>
                            </div>
                                :
                                <button type='button' className="px-10 py-2 bg-[#1D58E2] mx-auto w-fit text-white font-inter font-medium text-lg hover:bg-[#D2232A]" onClick={() => {
                                    props.setFieldValue('submitType', true)
                                    props.submitForm()
                                }}>FREE TRIAL</button>
                            }
                        </div>
                    </div>
                </div>
                {!freeTrial ? <div className="flex flex-col gap-10 items-center text-center py-16 bg-[#EFF4FF]">
                    <p className="font-poppins font-medium text-2xl">Before committing to an active plan, you can sign up for<br /> a free trial for <span className="text-[#1D58E2]">14 days</span></p>
                    <button type='button' className="bg-[#1D58E2] shadow-md px-6 py-2 font-inter font-medium text-lg text-white w-fit hover:bg-[#D2232A]" onClick={() => {
                        props.setFieldValue('submitType', true)
                        props.submitForm()
                    }}>Free Trial</button>
                </div>
                    :
                    <div className="flex flex-col gap-10 items-center text-center py-16 bg-[#EFF4FF]">
                        <p className="font-poppins px-2 font-medium text-2xl">Discover our exlcusive Business Plan. Flexible options with up to 99 licenses,available on monthly or yearly subscription!</p>
                        <button type='button' className="bg-[#1D58E2] shadow-md px-6 py-2 font-inter font-bold text-lg text-white w-fit hover:bg-[#D2232A]" onClick={() => {
                            props.setFieldValue('submitType', false)
                            props.submitForm()
                        }}>GET STARTED</button>
                    </div>
                }
            </Form>)}
        </Formik>
    )
}

export default BusinessForm